export default __webpack_public_path__ + "static/juice-efbf7766176433a8a1a582201310fabc.jpg";